import React, { useState, useEffect } from "react";
import {
    Input,
    Form,
    Col,
    Row,
    Button,
    Select,
    Collapse,
} from "antd";
import { odata } from "../Filters/Helper";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
const UserTableFilter = (props) => {
    const [form] = Form.useForm();
    const [phoneNumberCountry, setPhoneNumberCountry] = useState("");
    const onFinish = (values) => {
        {
            let query = "";
            const conditions = [];

            if (values.email) {
                conditions.push(`${odata.contains("email", values.email)}`);
            }
            if (values.firstName) {
                conditions.push(`${odata.contains("firstName", values.firstName)}`);
            }
            if (values.lastName) {
                conditions.push(`${odata.contains("lastName", values.lastName)}`);
            }
            if (values.phoneNumber) {
                conditions.push(`${odata.contains("phoneNumber", values.phoneNumber.replace(`${phoneNumberCountry}`, ""))}`);
            }
            if (values.isActive) {
                conditions.push(`isActive eq ${values.isActive}`);
            }

            if (conditions.length !== 0) {
                query = conditions.join(" and ");
                query = "$filter=" + query + "&"
            }
            if (props.onFinishFilter) props.onFinishFilter(query, values);
        }
    };
    const clearFilter = () => {
        form.resetFields();
        if (props.onClearFilter) {
            props.onClearFilter();
        }
    };
    const handlePhoneChange = (value, country) => {
        setPhoneNumberCountry(country.dialCode)
    };
    return (
        <Row id="filterArea" style={{ ...props.style, marginBottom: 50 }}>
            <Col span={24}>
                <Collapse>
                    <Collapse.Panel header="Filtreleme için tıklayınız.">
                        <Form
                            name="filter"
                            form={form}
                            initialValues={{
                                remember: true,
                            }}
                            layout="vertical"
                            onFinish={onFinish}
                        >
                            <Row style={{ flexDirection: "row" }}>

                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item name="email" label="Email :">
                                        <Input allowClear />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item name="firstName" label="Ad :">
                                        <Input allowClear />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item name="lastName" label="Soyad :">
                                        <Input allowClear />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item
                                        name="isActive"
                                        label="Durum :"
                                    >
                                        <Select
                                            allowClear
                                            placeholder="Tümü">
                                            <Select.Option key="true" value="true">
                                                Aktif
                                            </Select.Option>
                                            <Select.Option key="false" value="false">
                                                Pasif
                                            </Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12} lg={6}>
                                    <Form.Item
                                        name="phoneNumber"
                                        label="Telefon :"
                                    >
                                        <PhoneInput
                                            inputStyle={{ width: "100%" }}
                                            country="tr"
                                            masks={{ tr: "(...) ...-..-.." }}
                                            onChange={handlePhoneChange}
                                        /></Form.Item>
                                </Col>
                            </Row>
                            <Row style={{ flexDirection: "row" }}>
                                <Col span={24} style={{ textAlign: "right" }}>
                                    <Button
                                        danger
                                        size="small"
                                        icon={<CloseOutlined />}
                                        onClick={() => clearFilter()}
                                    >
                                        Sıfırla
                                    </Button>
                                    <Button
                                        type="primary"
                                        size="small"
                                        icon={<SearchOutlined />}
                                        style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                                        htmlType="submit"
                                    >
                                        Filtrele
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Collapse.Panel>
                </Collapse>
            </Col>
        </Row>
    );
};

export default UserTableFilter;